import { useMediaQuery } from "@mantine/hooks";

export default function useIsSmall(reSize: number = 768) {
  return useMediaQuery(`(max-width: ${reSize}px)`, undefined, {
    getInitialValueInEffect: false,
  });
}
